import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Typography,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

const BankBasedTransactionReportFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  const [transactionTypeSelect, setTransactionTypeSelect] = useState({
    data: [],
    loading: false
  });

  const [transactionTypeSelectValue, setTransactionTypeSelectValue] = useState(null)

  useEffect(() => {

    getBanks();
    getCurrencies();
    getTransactionTypes();

  }, []);

  useEffect(() => {
    if (props.data) {
      if (props.data.startDate && props.data.endDate) {
        props.data.dateRange = [moment(props.data.startDate), moment(props.data.endDate)]
      }

      setTransactionTypeSelectValue(props.data.transactionTypeGroupId);

      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getTransactionTypes = () => {
    setTransactionTypeSelect({
      ...transactionTypeSelect,
      loading: true,
    });

    RequestHandler.get(`/AccountTransaction/GetTransactionType`).then(
      (response) => {
        setTransactionTypeSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/Bank/GetFilterBank`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetByBankAccounts?$select=id,code,symbol`).then(
      (response) => {
        setCurrencySelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const onFinish = (values) => {
    {
      let query = {};

      if (values.bankId) {
        query.bankId = values.bankId;
      }

      if (values.dateRange) {
        [query.startDate, query.endDate] = values.dateRange;
      }

      if (values.currencyId != 1) {
        query.currencyId = values.currencyId;
        const activeCurrency = currencySelect.data.find(x => x.id == values.currencyId);
        query.currencyCode = activeCurrency.code;
        query.currencySymbol = activeCurrency.symbol;
      } else {
        query.currencyId = "1";
        query.currencyCode = "TRY";
        query.currencySymbol = "₺";
      }

      if (values.transactionTypeGroupValue) {
        query.transactionTypeGroupId = values.transactionTypeGroupValue;
      }

      if (props.onFinishFilter) props.onFinishFilter(query,);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="valueReportFilter"
              form={form}
              initialValues={{
                remember: true,
                currencyId: 1,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.text} value={item.text}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="dateRange" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      picker={props.monthly ? "month" : "date"}
                      format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                { props.showTransactionTypeFilter ?
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionTypeGroupValue" label="İşlem Tipi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      defaultValue={transactionTypeSelectValue ? parseInt(transactionTypeSelectValue) : null}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionTypeSelect.loading}
                    >
                      {transactionTypeSelect.data.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> : <></> }

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="TRY"
                      loading={currencySelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {currencySelect.data.map((item) => (
                        <Select.Option key={item.id} value={`${item.id}`}>
                          {item.code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default BankBasedTransactionReportFilter;
